import Component from '../inherited/Component'
import rivets from 'rivets'
import Helpers from '../lib/Helpers'
import AjaxApi from '../lib/AjaxApi'

class ScentDesigner extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._jsonElem = this._elem.querySelector('[data-scent-designer-json]')
    this._quantityElem = this._elem.querySelector('[data-quantity]')
    this._data = JSON.parse(this._jsonElem.innerHTML)
    this._jquery = window.$ || null
  }

  async mount () {
    this._data = await this.prepareData(this._data)

    this._binders()
    this._render()
  }

  async prepareData (data) {

    data.product.selected_variant = data.product.variants[0]

    for(let [index, step] of data.steps.entries()) {
        step.index = index + 1
        step.selected = false
        step.selected_temp = false
        step.slideout = false
    }

    data.current_step_index = 0
    data.step_count = data.steps.length
    data.canPurchase = false
 
    return data
  }

  _render () {
    this._bind = rivets.bind(this._elem, this._getModel())
    this._elem.classList.add('rendered')
    this._ctx.emit('radiant--lazy-load-update')
  }

  _update () {
    this._data.canPurchase = false
    for(let step of this._data.steps) {
        if(step.selected) {
            this._data.canPurchase = true
            break
        }
    }
  }
   
  _getModel () {
    return {
      data: this._data,
      controller: {
        selectOption: async (e, model) => {
            if(model.step.selected_temp != model.option) {
                model.step.selected_temp = model.option
            } else {
                model.step.selected_temp = false
            }
        },
        removeOption: async (e, model) => {
            model.step.selected = false
            this._update()
        },
        cancelSlideout: async (e, model) => {
            model.step.selected_temp = false
            model.controller.toggleSlideout(e, model)
        },
        applySlideout: async (e, model) => {
            model.step.selected = model.step.selected_temp
            model.step.selected_temp = false
            model.controller.toggleSlideout(e, model)
            this._elem.scrollIntoView({
              'block': 'center',
              'behavior': 'smooth'
            })
            this._update()
        },
        toggleSlideout: async (e, model) => {
            model.step.slideout = !model.step.slideout
            document.documentElement.classList.toggle('slideout-open')
        },
        updateMessage: async (e, model) => {
            if(model.step.personalisation_message.trim() != '') {
                model.step.selected_temp = model.step.personalisation_message
            } else {
                model.step.selected_temp = false
            }
        },
        addToCart: async (e, model) => {
          try {
            if (this._data.adding_to_cart) return
            this._data.adding_to_cart = true

            let items = []

            let properties = {}

            for(let step of this._data.steps) {
                if(step.selected) {
                    properties[step.title] = step.selected.title ? step.selected.title : step.selected
                }
            }

            items.push({
                id: this._data.product.selected_variant.id,
                quantity: Number(this._quantityElem.value),
                properties: properties
            })

            console.error(items)

            let data = await AjaxApi.addToCart({
              items: items
            }, this._ctx.getState())

            setTimeout(() => {
              window.location = this._ctx.getState().routes.cart
            }, 500)
          } catch (e) {
            if (e.response) {
              console.log(e.response)
              vex.dialog.alert(e.response.data.description)
              this._data.adding_to_cart = false
            }
          }
        }
      }
    }
  }

  _binders () {
    rivets.formatters.getSrcSet = (src, size) => {
      return src ? `${Helpers.getSizedImageUrl(src, size)} 1x, ${Helpers.getSizedImageUrl(src, size + '@2x')} 2x` : ''
    }

    rivets.formatters.getSizedImage = (src, size) => {
      return src ? Helpers.getSizedImageUrl(src, size) : ''
    }

    rivets.formatters.toArr = (count) => {
      let result = []
      for (let i = 0; i < count; i++) {
        result.push(i)
      }
      return result
    }

    rivets.formatters.moneyWithFree = (value) => {
      return value > 0 ? Helpers.formatMoney(value, this._ctx.getState()) : this._ctx.getState().locale.free
    }

    rivets.formatters.money = (value) => {
      return Helpers.formatMoney(value, this._ctx.getState())
    }

    rivets.formatters.getProductCount = (products, product, variant) => {
      return products.filter(item => item.handle === product.handle && item.selected_variant && item.selected_variant.id === variant.id).length
    }

    rivets.formatters.getIndex = (arr, index) => {
      return arr[index]
    }

    rivets.formatters.length = (arr) => {
      return arr ? arr.length : 0
    }

    rivets.formatters.limitMessage = (value, limit) => {
        if(value) {
            return value.substring(0, (limit - 1))
        }
    }

    rivets.formatters.canPurchase = (steps) => {
        for(let step of steps) {
            if(step.selected) {
                return true
            }
        }
        return false
    }

    rivets.formatters.handleize = (arr) => {
      return Helpers.handleize(arr)
    }

    rivets.formatters.eq = (val, val2) => {
      return val === val2
    }

    rivets.formatters.gt = (val, val2) => {
      return val > val2
    }

    rivets.formatters.gte = (val, val2) => {
      return val >= val2
    }

    rivets.formatters.not = (val) => {
      return !val
    }

    rivets.formatters.isSelected = (value, selectedValues) => {
        return selectedValues.find(selectedValue => value === selectedValue)
    }

    rivets.formatters.getTotal = () => {
        return this._data.steps.reduce((acc, step) => {
            return step.selected.price
        }, 0)
    }

    rivets.formatters.isFinalStep = (index, steps) => {
        return index > steps.length
    }

    rivets.formatters.pluralize = (count, one, multiple) => {
      return count === 1 ? one : multiple
    }

    rivets.formatters.prepend = (one, two) => {
      return `${two}${one}`
    }
 
    rivets.formatters.toJson = (item) => {
      return JSON.stringify(item)
    }

    rivets.binders['set-class'] = function(el, value){
      if (el.classList.contains(value)) {
        el.classList.remove(value)
      }
      el.classList.add(value)
    }
  }

}

export default ScentDesigner
